import React from 'react'
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
export default function Test() {
  return (
   <DatePicker />
  )
}
